import { createAction } from "redux-actions";

export const API_KEY_LIST = "API_KEY_LIST";
export const apiKeyList = createAction(API_KEY_LIST);

export const CREATE_API_KEY = "CREATE_API_KEY";
export const createApiKey = createAction(CREATE_API_KEY);

export const DETAIL_API_KEY = "DETAIL_API_KEY";
export const detailApiKey = createAction(DETAIL_API_KEY);

export const UPDATE_API_KEY = "UPDATE_API_KEY";
export const updateApiKey = createAction(UPDATE_API_KEY);

export const DELETE_API_KEY = "DELETE_API_KEY";
export const deleteApiKey = createAction(DELETE_API_KEY);
